import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myHrRoleFilterState = atom({
  key: "myHrRoleFilterState",
  default: {
    company: [],
    orgUnit: [],
    workingPlace: [],
    jobClassGroup: [],
    payOffice: [],
    contract: [],
  },
  effects_UNSTABLE: [ocPersistAtom],
});
